export default __webpack_public_path__ + "41a9ad8d38d4f4e767c9eb7b746f66fd.woff2";